import * as Icons from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export function CategoryPicker({ value, onChange, cats }) {
  const { lang } = useI18n();
  if (!cats?.length) return <p className="text-xs text-slate-400">…</p>;
  return (
    <div
      data-testid="category-picker"
      className="grid grid-cols-3 sm:grid-cols-5 gap-2.5 p-1 pb-4"
    >
      {cats.map((c) => {
        const Icon = Icons[c.icon] || Icons.Circle;
        const active = value === c.id;
        return (
          <button
            key={c.id}
            type="button"
            data-testid={`cat-${c.id}`}
            onClick={() => onChange(c.id)}
            className={`flex flex-col items-center gap-1.5 p-2.5 rounded-2xl transition-all ${
              active ? "neu-inset" : "neu-sm hover:-translate-y-0.5"
            }`}
          >
            <div
              className={`w-12 h-12 rounded-full grid place-items-center shrink-0 ${
                active
                  ? "neu-fill-blue text-white shadow-lg shadow-blue-900/25"
                  : "neu-sm text-[#1e3a8a]"
              }`}
            >
              <Icon className="w-5 h-5" strokeWidth={2.1} />
            </div>
            <span
              className={`text-[11px] leading-tight text-center line-clamp-2 ${
                active ? "font-bold neu-accent-blue" : "text-slate-600"
              }`}
            >
              {c[lang] || c.en}
            </span>
          </button>
        );
      })}
    </div>
  );
}
